<template>
    <div id="bst-wrap">
        <div class="l-project-wrap l-project-wrap--mypage is-hide">
            <header class="l-header l-header--top">
                <PublicPageHeader />
            </header>
            <section class="l-content-area">
                <div class="l-content">
                    <section class="p-bloc p-bloc--mypage">
                        <div class="p-bloc__content l-wrap__outer">
                            <div class="l-wrap__inner">
                                <section class="p-mypage">
                                    <div class="p-mypage__content">
                                        <div class="mypage-content">
                                            <div class="p-mypage__page mypage-bloc">
                                                <div class="mypage-bloc__content">
                                                    <div class="page__bloc page__bloc--terms c-kiyaku">
                                                        <header class="article-header">
                                                            <h1>ビジネスhubsynch</h1>
                                                        </header>

                                                        <!-- post -->
                                                        <section class="article-content">
                                                            <p>hubsynchは現在より多くのマーチャント様にhubsynchマーチャントアカウントをご利用頂けるように準備を進めております。
                                                            </p>
                                                            <p>hubsynchはhubsynch単体でご利用頂くものではなく、hubsynchとサービスアプリ（Wrapper
                                                                Apps）により、hubsynchアカウントユーザーとhubsynchマーチャントアカウントユーザーにご利用頂ける仕組みです。
                                                            </p>
                                                            <p style="text-align: center;"><img
                                                                        class="aligncenter size-full wp-image-545"
                                                                        alt="illust_business_1"
                                                                        src="@/assets/img/static_pages/illust_business_1.png"
                                                                        width="860" height="810"><br>
                                                            </p>
                                                            <h2>hubsynchの機能</h2>
                                                            <p>hubsynchが提供する機能は大きく分けて下記の通りです。</p>
                                                            <ul>
                                                                <li>ユーザー管理機能</li>
                                                                <li>マーチャント管理機能</li>
                                                                <li>アプリ管理機能</li>
                                                                <li>ログ管理機能</li>
                                                                <li>ペイメント機能</li>
                                                                <li>その他機能開発中</li>
                                                            </ul>
                                                            <p style="text-align: center;"><img
                                                                        class="aligncenter size-full wp-image-506"
                                                                        alt="illust_business_2"
                                                                        src="@/assets/img/static_pages/illust_business_2.png"
                                                                        width="860" height="425"></p>
                                                            <p>Wrapper
                                                                Appsは、独自のシステムを構築頂き、必要な機能だけhubsynchでご利用頂くことが可能になっております。
                                                            </p>
                                                            <p>例えば、ECサイトの構築においては通常のオープンソースもしくは独自でアプリを構築して頂き、決済およびユーザー管理についてはhubsynchをご利用頂くことが可能です。
                                                            </p>
                                                            <h2>hubsynchビジネスパートナー</h2>
                                                            <p>hubsynchは多くのビジネスパートナーとともに成長していくサービスです。</p>
                                                            <p>Wrapper Appsをご利用頂けるマーチャント様、Wrapper
                                                                Appsの開発ご担当者様、決済代行会社様、並びにID連携等をご検討の企業様とともに、今後のhubsynchをよりよいサービスにしていきたいと考えております。
                                                            </p>
                                                            <p>準備ができ次第、順次皆様にご連絡させて頂きたく存じます。何卒よろしくお願い申し上げます。</p>
                                                        </section>
                                                        <!-- -->

                                                        <!-- btn-contact -->
                                                        <div id="btn-contact-wrap" class="btn-wrap contact-highlight">
                                                            <p class="txt">hubsynchにご興味をお持ちの方はこちらからお問い合わせください</p>
                                                            <p class="btn"><router-link :to="{ name: 'contact.us' }">お問合せ</router-link></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
            <Footer v-if="isLoggedIn"/>
            <PublicFooter v-else/>
        </div>
    </div>
</template>
<script setup>
import PublicPageHeader from "@/components/PublicPageHeader.vue";
import { ref, onBeforeMount } from "vue";
import { useSessionStore } from "@/stores/sessionStore";
import Footer from "@/components/Footer.vue";
import PublicFooter from "@/components/PublicFooter.vue";

const sessionStore = useSessionStore();
const isLoggedIn = ref(false);
onBeforeMount(async () => {
    isLoggedIn.value = sessionStore.isLoggedIn();
});
</script>